import React from 'react';
import { sendEvent } from '@mrkt/features/Platform/googleAnalytics';
import { CTABtnAsLink, CTABtnArrow } from '../../Style';

type StatsCTABtnProps = {
  url: string;
  action: string;
  label: string;
  title: string;
};

const StatsCTABtn = React.memo((props: StatsCTABtnProps) => {
  return (
    <CTABtnAsLink
      to={props.url}
      onClick={() =>
        sendEvent({
          eventCategory: 'Navigate',
          eventAction: `${props.action}`,
          eventLabel: `${props.label}`,
        })
      }
    >
      {props.title}
      <CTABtnArrow />
    </CTABtnAsLink>
  );
});

/* eslint-disable-next-line import/no-default-export */
export default StatsCTABtn;
